<script lang="ts">
    import type {ComponentStyle} from '../types';

    export let panelStyle: ComponentStyle = 'default';
    export let additionalClasses = ''
</script>

<template>
    <div class="panel panel-{panelStyle} {additionalClasses}">
        {#if $$slots.heading}
            <div class="panel-heading">
                <slot name="heading"></slot>
            </div>
        {/if}

        <div class="panel-body">
            <slot></slot>
        </div>

        {#if $$slots.footer}
            <div class="panel-footer">
                <slot name="footer"></slot>
            </div>
        {/if}
    </div>
</template>
